<template>
  <div>
    <Alert v-if="showErrors" type="error" @close="showErrors = false">
      <div v-for="error in errors.items" :key="error.id">
        {{error.msg}}
      </div>
    </Alert>

    <form novalidate id="crl_name_form" @submit.prevent="createNewCrl">
      <label for="name">Name</label>
      <input
        type="text"
        id="name"
        name="name"
        class="list-name"
        v-validate="'required'"
        v-model="name">
      <div class="actions">
        <button class="btn-primary btn-submit test-create-new-list-button" type="submit">
          Create New List
        </button>
        <button
          class="btn-tertiary cancel test-create-new-list-cancel-button"
          type="button"
          @click="cancel">
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Alert from '@/components/Shared/Alert.vue';

export default {
  data() {
    return {
      name: '',
      showErrors: false,
      domain: process.env.VUE_APP_HG_CLASSIC,
    };
  },
  props: {
    hgReportId: {
      type: String,
      required: true,
    },
  },
  components: {
    Alert,
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'errors.items'(newVal) {
      if (newVal.length < 1) {
        this.showErrors = false;
      }
    },
  },
  methods: {
    createNewCrl() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const encodedName = encodeURI(this.name);
          window.location = `${this.domain}gingerbread/newList.htmls?rid=${this.hgReportId}&listName=${encodedName}`;
        }

        if (!result) {
          this.showErrors = true;
        }
      });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.list-name {
  width: 100%
}

.actions {
  text-align: center;
}

button {
  margin: 0 7px;
}

@media all and (max-width: 655px) {
  .cancel {
    margin-top: 30px;
  }
}
</style>
